<template>
  <div class="dashboard-block">
    <h2>Other Settings</h2>

    <form>
      <div class="row row-clear-md-8">
        <div class="col-md-5">
          <div :class="$hasErrorClass($v.stateCompletedBookingsDefaultDateRange, 'form-group')">
            <label class="control-label">Default date range for completed bookings on select stars</label>
             <flatpickr
                v-model="$v.stateCompletedBookingsDefaultDateRange.$model"
                :config="flatPickerDateConfig"
                ref="date"
                class="form-control"
                name="completed_bookings_default_date_range"/>
            <vuelidate-help label="Date range" :field="$v.stateCompletedBookingsDefaultDateRange"/>
          </div>
        </div>
      </div>

      <ladda-button
        class="btn btn-success"
        :click="handleSaveCallback">
        <i class="fa fa-check"></i> Save Changes
      </ladda-button>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/settings'
import { pick } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'
import Flatpickr from 'vue-flatpickr-component'
import { notify } from 'utils'

export default {
  mixins: [stateMapper],

  components: { VuelidateHelp, Flatpickr },

  validations: {
    stateCompletedBookingsDefaultDateRange: {
      required
    }
  },

  data () {
    return {
      flatPickerDateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        wrap: true,
        mode: 'range'
      }
    }
  },

  methods: {
    ...mapActions('settings', ['updateSettings']),

    handleSaveCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Validation failed. Please fix them and try again`)
        return Promise.resolve()
      }
      return this.updateSettings(pick(this.settings, [
        'completed_bookings_default_date_range'
      ]))
    }
  }
}
</script>
